import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import PeriodicTable from './components/PeriodicTable';
import GroupPage from './pages/GroupPage';
import NavBar from './components/NavBar';
export function App() {
  return <div className="min-h-screen bg-gray-100" data-id="element-0">
      <Router data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<div className="container mx-auto px-4 py-8" data-id="element-4">
                <NavBar data-id="element-5" />
                <h1 className="text-4xl font-bold text-center mb-8 text-blue-800" data-id="element-6">
                  Periodic Table Explorer
                </h1>
                <PeriodicTable data-id="element-7" />
              </div>} data-id="element-3" />
          <Route path="/group/:groupId" element={<div className="container mx-auto px-4 py-8" data-id="element-9">
                <NavBar data-id="element-10" />
                <h1 className="text-4xl font-bold text-center mb-8 text-blue-800" data-id="element-11">
                  Periodic Table Explorer
                </h1>
                <GroupPage data-id="element-12" />
              </div>} data-id="element-8" />
          <Route path="*" element={<Navigate to="/" replace data-id="element-14" />} data-id="element-13" />
        </Routes>
      </Router>
    </div>;
}